













































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import StatusPanel from '@/components/StatusPanel.vue';
import BaseInfoPanel from '@/components/BaseInfoPanel.vue';
import { PaginationPanel } from '@/components';
import collapse from '../../utils/collapse.js';
import publicFunc from '../../common/util/publicFunc';
import { PayApi, ExpenseType } from '@/http';
import { enums } from '@/common/enums';
import { formRules } from '@/common/util/validator';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import { upload } from '../../common/util/ossUploadService';
import ElImageViewer from '@/components/imageviewer.vue';
import addCostPopup from './components/addCostPopup.vue';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        StatusPanel,
        BaseInfoPanel,
        ListFilterPanel,
        ElImageViewer,
        addCostPopup
    },
})
export default class PaystatementDetails extends Vue {
    public $refs: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        form: HTMLFormElement;
        basicForm: HTMLFormElement;
        addCostPopup: HTMLFormElement;
        upload: HTMLFormElement;
        addFeeBillExpenseForm: HTMLFormElement;
    };
    public labelPosition: string = 'right';
    public title: string = '对账单详情';
    public description: string =
        '1.查看对账单的基本信息以及费用明细   2.账单状态为待审核，支持对费用对账单进行审核退回或审核通过  3.支持用户导出对账单信息  4.支持以对账单的维度，新增费用';
    public basicForm: PayApi.FeeBillItemVM = {};
    public activeName: string = 'first';
    public formRules = formRules;
    public isActive: boolean = false;
    public publicFunc: any = publicFunc;
    public searchValue: PayApi.GetfeecarrierorderlistPayload = {
        carrierOrderCode: '',
        carrierOrderStatus: '',
        receiptStatus: '',
        billId: '',
        asc: true,
        orderBy: '',
    };
    public receiptStatusEnum = enums.receiptStatusEnum;
    public waybillStatusEnum = enums.wayBillStatusType;
    public loading = false;
    public rePagin = false;
    public total = 0;
    public tableData: Array<PayApi.FeeCarrierOrderItemVM> = [];

    public id: string = '';
    public created() {}
    public mounted() {
        this.id = String(this.$route.query.id);
        this.getfeebill();
        this.getfeecarrierorderlist();
        this.GetfeeTypeList();
    }
    public feeBillItem: PayApi.FeeBillItemVM = {};
    public canDel: boolean = false; //删除按钮显隐
    public async getfeebill() {
        PayApi.Getfeebill(this.id).then((res) => {
            console.log(res);
            this.basicForm = res;
            switch (res.feeBillStatusStr) {
                case '待审核':
                    this.canDel = true;
                    break;
                case '审核退回':
                    this.canDel = false;
                    break;
                case '已审核':
                    this.canDel = false;
                    break;

                default:
                    break;
            }
        });
    }
    public feeTypeList = [];
    public async GetfeeTypeList() {
        await ExpenseType.GetList({
            isEnable: true,
            skip: -1,
            count: -1,
        }).then((res) => {
            this.feeTypeList = res.data;
        });
    }
    public dialogConfig: any = {
        title: '',
        show: false,
    };
    public currDialog: string = 'A';
    public setColor: boolean = true;
    public srow: any;
    public undo(row) {
        this.setColor = true;
        this.currDialog = 'A';
        this.srow = row;
        this.dialogConfig = {
            title: '撤销该运单相关费用',
            show: true,
        };
    }
    public approvedBtn() {
        this.setColor = false;
        this.currDialog = 'B';
        this.dialogConfig = {
            title: '审核通过对账单',
            show: true,
        };
    }
    public delBtn() {
        this.setColor = true;
        this.currDialog = 'C';
        this.dialogConfig = {
            title: '删除对账单',
            show: true,
        };
    }
    public approvedToBack() {
        this.setColor = true;
        this.currDialog = 'D';
        this.dialogConfig = {
            title: '退回对账单',
            show: true,
        };
    }
    public addFeeBill() {
        this.currDialog = 'E';
        this.addFeeBillExpenseForm = {
            feeBillId:this.basicForm.id,
            amount:'',
            expenseType: '',
            expenseExplain: ''
        }
       this.dialogVisible = true;
    }
    public toDel(row){
        this.setColor = true;
        this.currDialog = 'F';
        this.srow = row;
        this.dialogConfig = {
            title: '删除此费用',
            show: true,
        };
    }

    public dialogVisible: boolean = false;

    public addFeeBillExpenseForm: PayApi.AddFeeBillExpenseVM = {
        feeBillId: '',
        amount: '',
        expenseType: '',
        expenseExplain: ''
    }

    public handleClose(){
        this.$refs.addFeeBillExpenseForm.resetFields();
        this.dialogVisible = false;
    }


    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }
    confirmOk() {
        switch (this.currDialog) {
            case 'A':
                 PayApi.DelCoFee({  carrierOrderId: this.srow.id,billId: this.basicForm.id }).then((res) => {
                    this.$message({
                        type: 'success',
                        message: '费用撤销成功！',
                    });
                    this.dialogConfig.show = false;
                    this.getfeebill();
                    this.getfeecarrierorderlist();
                });
                break;
            case 'B':
                PayApi.UpdateBillStatus({ id: this.basicForm.id, feeBillStatus: '4' }).then((res) => {
                    this.$message({
                        type: 'success',
                        message: '账单审核通过！',
                    });
                    this.dialogConfig.show = false;
                    this.$router.push({
                        path: '/payStatement',
                    });
                });
                break;
            case 'C':
                PayApi.DeleteBill(this.basicForm.id).then((res) => {
                    this.$message({
                        type: 'success',
                        message: '账单删除成功！',
                    });
                    this.dialogConfig.show = false;
                    this.$router.push({
                        path: '/payStatement',
                    });
                });
                break;
            case 'D':
                PayApi.UpdateBillStatus({ id: this.basicForm.id, feeBillStatus: '3' }).then((res) => {
                    this.$message({
                        type: 'success',
                        message: '账单退回成功！',
                    });
                    this.dialogConfig.show = false;
                    this.getfeebill();
                    this.getfeecarrierorderlist();
                });
                break;
             case 'E':
                this.$refs.addFeeBillExpenseForm.validate( async(vaild)=>{
                    if(vaild){
                        PayApi.AddFeeBillYS(this.addFeeBillExpenseForm).then((res) => {
                            this.$message({
                                type: 'success',
                                message: '费用新增成功！',
                            });
                            this.$refs.addFeeBillExpenseForm.resetFields();
                            this.dialogVisible = false;
                            this.getfeebill();
                            this.getfeecarrierorderlist();
                             this.loadPayList();
                        });
                    }
                })
                break;
                case 'F':
                    PayApi.DeleteBillFee(this.srow.id).then((res) => {
                        this.$message({
                            type: 'success',
                            message: '删除成功！',
                        });
                        this.dialogConfig.show = false;
                        this.getfeebill();
                        this.getfeecarrierorderlist();
                        this.loadPayList();
                    });
                break;

            default:
                break;
        }
    }

    public async exportBtn(){
        let data = await PayApi.GetfeecarrierorderlistExport({
              ...this.searchValue,
              skip: this.searchPagin.skip,
              count: this.searchPagin.count
        });
    }

    public async getfeecarrierorderlist() {
        this.loading = true;
        this.searchValue.billId = this.id;
        PayApi.Getfeecarrierorderlist({
            ...this.searchValue,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                this.tableData = res.data;
                let skip = this.searchPagin.skip;
                this.tableData.map((item, index) => {
                    item.index = skip++ + 1;
                });
                this.total = res.total;
                this.loading = false;
            })
            .catch((e) => {
                this.loading = false;
            });
    }
    /**
     * 查询
     */
    public searchFunc() {
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }
    //重置
    public resetSearchValue() {
        this.searchValue = {
            carrierOrderCode: '',
            carrierOrderStatus: '',
            receiptStatus: '',
            billId: '',
            asc: true,
            orderBy: '',
        };
        this.searchFunc();
    }
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        this.getfeecarrierorderlist();
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex, //给每一行添加不可枚举属性rowIndex来标识当前行
            writable: true,
            enumerable: false,
        });
    }

    public payData = [];
 
  

    public async loadPayList(){
        await PayApi.GetBillFeeList( this.id)
            .then((res) => {
               this.payData = res.map((v,i)=>{return {
                   index: i+1,
                   amount: v.amount,
                   creator: v.creator,
                   expenseExplain: v.expenseExplain,
                   expenseType: v.expenseType,
                   creationTime: v.creationTime,
                   id: v.id,
                }});
              
            })
            .catch((err) => {

            });
    }


    public toSkip(row) {
         this.$router.push({
                path: '/WayBillDetail',
                query: {
                    orderId: row.id,
                    type: 'fee',
                    fee: '3',
                    feeId: this.id,
                },
            });
    }
    public getcarriageWayColor(val) {
        switch (val) {
            case '待派车':
                return 'c_yellow';
            case '待发货':
                return 'c_yellow';
            case '在途中':
                return 'c_blue';
            case '已送达':
                return 'c_green';
            case '已终结':
                return 'c_red';

            default:
                break;
        }
    }
    public getReceiptColor(val) {
        switch (val) {
            case '回单未回':
                return 'c_red';
            case '回单已上传':
                return 'c_yellow';
            case '回单已确认':
                return 'c_blue';
            case '回单已签收':
                return 'c_green';

            default:
                break;
        }
    }
    /**对账单列表手动排序 */
    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'realDeliveryTime':
                {
                    this.searchValue.orderBy = '1';
                }
                break;
            case 'carrierOrderStatusStr':
                {
                    this.searchValue.orderBy = '3';
                }
                break;
        }
        this.getfeecarrierorderlist();
    }
    public handleClick() {
        if(this.activeName=='first'){
            this.getfeecarrierorderlist();
        }else{
          this.loadPayList();  
        }
    }

    public addFee() {
        this.$refs.addCostPopup.open(this.basicForm.id);
    }
    public back() {
        this.$router.push({
            path: '/payStatement',
        });
        
    }
    toDetail(row, type, index) {
            this.$router.push({
                path: '/orderDetailcc',
                query: {
                    id: row.orderList[index].id,
                    name: 'detail',
                    from: 'PaystatementDetails',
                    status: row.carrierOrderStatus,
                    carCode: row.carCode,
                    deliveryAddress: row.orderList[0].originAddress,
                    arrivalAddress: row.orderList[0].arrivalAddress,
                    driverPhone: row.orderList[0].driverPhone,
                },
            });
    }
}
